import _jsx from "@babel/runtime/helpers/jsx";
var _div, _div2;
import React from 'react';
function FilterPlaceholder() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx("div", {
    "data-cmp": "filterPlaceholder"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "container-fluid padding-4"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "row skeleton__loading"
  }, void 0, _div || (_div = /*#__PURE__*/_jsx("div", {
    className: "col-xs-12 margin-bottom-6"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "skeleton__headline skeleton__placeholder"
  }))), /*#__PURE__*/_jsx("div", {
    className: "col-xs-12"
  }, void 0, Array(3).fill(_div2 || (_div2 = /*#__PURE__*/_jsx("div", {
    className: "row"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "col-xs-2"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "skeleton__text skeleton__placeholder"
  })), /*#__PURE__*/_jsx("div", {
    className: "col-xs-10"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "skeleton__text skeleton__placeholder"
  }))))))))), /*#__PURE__*/_jsx("hr", {
    className: "margin-0",
    style: {
      borderTop: '1px solid #e1e4e8'
    }
  }));
}
export default FilterPlaceholder;